/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);


const acceptShare = Vue.resource('shares{/id}/accept');



export default acceptShare;



// WEBPACK FOOTER //
// ./src/resources/acceptShare.js